export const MaintenanceTicketType = {
  PREVENTIVE: 'PREVENTIVE',
  CURATIVE: 'CURATIVE',
} as const;
export type MaintenanceTicketType =
  (typeof MaintenanceTicketType)[keyof typeof MaintenanceTicketType];

export const MaintenanceTicketStatus = {
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  CLOSED: 'CLOSED',
  CANCELLED: 'CANCELLED',
} as const;
export type MaintenanceTicketStatus =
  (typeof MaintenanceTicketStatus)[keyof typeof MaintenanceTicketStatus];

export const WorkOrderStatus = {
  PLANNED: 'PLANNED',
  ASSIGNED: 'ASSIGNED',
  IN_PROGRESS: 'IN_PROGRESS',
  ON_HOLD: 'ON_HOLD',
  COMPLETED: 'COMPLETED',
  CLOSED: 'CLOSED',
  ARCHIVED: 'ARCHIVED',
  CANCELLED: 'CANCELLED',
} as const;
export type WorkOrderStatus =
  (typeof WorkOrderStatus)[keyof typeof WorkOrderStatus];

export const TicketWorkOrderMembershipStatus = {
  ACTIVE: 'ACTIVE',
  MOVED_OUT: 'MOVED_OUT',
  CANCELLED: 'CANCELLED',
} as const;
export type TicketWorkOrderMembershipStatus =
  (typeof TicketWorkOrderMembershipStatus)[keyof typeof TicketWorkOrderMembershipStatus];

export const WorkOrderExecutionResult = {
  COMPLETED_OK: 'COMPLETED_OK',
  COMPLETED_WITH_ISSUE: 'COMPLETED_WITH_ISSUE',
  NOT_DONE: 'NOT_DONE',
  CANCELLED: 'CANCELLED',
} as const;
export type WorkOrderExecutionResult =
  (typeof WorkOrderExecutionResult)[keyof typeof WorkOrderExecutionResult];

export const TicketWorkOrderEventType = {
  CREATED: 'CREATED',
  ASSIGNED: 'ASSIGNED',
  UNASSIGNED: 'UNASSIGNED',
  BUNDLED: 'BUNDLED',
  UNBUNDLED: 'UNBUNDLED',
  MOVED: 'MOVED',
  STARTED: 'STARTED',
  REPORT_SUBMITTED: 'REPORT_SUBMITTED',
  COMPLETED: 'COMPLETED',
  WO_COMPLETED: 'WO_COMPLETED',
  WO_CLOSED: 'WO_CLOSED',
  CANCELLED: 'CANCELLED',
  ARCHIVED: 'ARCHIVED',
  REOPENED: 'REOPENED',
  STATUS_CHANGED: 'STATUS_CHANGED',
  WO_MERGED: 'WO_MERGED',
} as const;
export type TicketWorkOrderEventType =
  (typeof TicketWorkOrderEventType)[keyof typeof TicketWorkOrderEventType];
